import styled from '@emotion/styled';
import { IFooter, IFooterLink } from '@interfaces';
import React from 'react';
import { __ } from '../../../../utils/translation-service';
import { screenSize } from '../../header/header-desktop-old/variables';
import { FooterContactInfo } from './FooterContactInfo';
import { FooterIcons } from './FooterIcons';
import { FooterLink } from './FooterLink';
import { Seal } from './Seal';
import { LocaleConfigContext } from '../../../../../src/contexts/locale-config/locale-config';

class FooterLinkList extends React.Component<{ list: IFooterLink[] }, {}> {
    public render() {
        return (
            <ul className="list-unstyled">
                {this.props.list
                    ? this.props.list.map((item, key) => (
                          <li key={key}>
                              <FooterLink {...item} />
                          </li>
                      ))
                    : ''}
            </ul>
        );
    }
}

export class FooterLinkGroup extends React.Component<
    { className?: string; title: string; list: IFooterLink[] },
    {}
> {
    public render() {
        return (
            <li className={this.props.className ? this.props.className : ''}>
                <h3
                    className="text-uppercase"
                    style={{
                        lineHeight: '1.1',
                        fontSize: '12px',
                        fontFamily: 'Arial,Helvetica,sans-serif',
                    }}
                >
                    {this.props.title}
                </h3>
                <FooterLinkList list={this.props.list} />
            </li>
        );
    }
}

const SealStyled = styled(Seal)`
    padding-bottom: 20px;
    border-bottom: 1px solid #c3c3c3;
    border-top: 1px solid #c3c3c3;

    @media (max-width: ${screenSize.smMax}) {
        display: none;
    }
`;
interface IProps {
    footer: IFooter;
}

export const FooterNav = ({ footer }: IProps) => {
    const localeConfig = React.useContext(LocaleConfigContext);

    const showSeal = localeConfig.code === 'de';

    return (
        <div className="container">
            <FooterIcons
                socialMediaIcons={footer.socialMediaIcons}
                paymentMethods={footer.paymentMethods}
                awards={footer.awards}
                security={footer.security}
            />

            <div className="clearfix" />
            {showSeal && <SealStyled />}

            <nav className="footer_nav">
                <ul className="list-inline col-xs-12 col-md-9 noPadding">
                    <FooterLinkGroup
                        className="col-xs-6 col-is-4 col-sm-4"
                        title={footer.columnOne.headline}
                        list={footer.columnOne.items}
                    />
                    <FooterLinkGroup
                        className="col-xs-6 col-is-4 col-sm-4"
                        title={footer.columnTwo.headline}
                        list={footer.columnTwo.items}
                    />
                    <FooterLinkGroup
                        className="col-xs-12 col-is-4 col-sm-4"
                        title={footer.columnThree.headline}
                        list={footer.columnThree.items}
                    />
                    <FooterLinkGroup
                        className="col-xs-6 col-is-4 col-sm-4"
                        title={footer.columnFour.headline}
                        list={footer.columnFour.items}
                    />
                    <FooterLinkGroup
                        className="col-xs-6 col-is-4 col-sm-4"
                        title={footer.columnFive.headline}
                        list={footer.columnFive.items}
                    />
                </ul>

                <div className="col-xs-12 col-md-3 noPadding">
                    <FooterContactInfo {...footer.contactInfo} title={__('aboutUs')} />
                </div>
            </nav>

            <div className="clearfix" />

            <div className="col-xs-12 noPadding">
                <small>{footer.copyright}</small>
            </div>
        </div>
    );
};
